import React from 'react';
import { CircularProgress } from '@mui/material';
import { FiAlertCircle } from 'react-icons/fi';
import { useWebLocale } from '../../../../contexts/WebLocaleContext';
import './AlbumIntro.css';

export default function AlbumLoadState({ loading, error, album, onRetry, children }) {
  const { locale } = useWebLocale();
  const en = locale === 'en';
  if (loading && !album)
    return (
      <div
        className="pp-album-load-state"
        role="status"
        aria-label={en ? 'Loading' : '불러오는 중'}
      >
        <CircularProgress size={28} color="inherit" />
      </div>
    );
  const failed = error || !album;
  return (
    <>
      {failed && (
        <div className={`pp-album-load-state${album ? ' is-inline' : ''}`} role="alert">
          <FiAlertCircle size={28} aria-hidden="true" />
          <h2>{en ? 'Something went wrong' : '잠시 문제가 생겼습니다'}</h2>
          <p>{en ? 'We could not load the content.' : '콘텐츠를 불러오지 못했습니다.'}</p>
          <button type="button" onClick={onRetry}>
            {en ? 'Try Again' : '다시 시도'}
          </button>
        </div>
      )}
      {album && children}
    </>
  );
}
